import { PRELOAD_HYPERDRIVE_MODEL_EVENT } from '@yme/components/Link/constants';
const modelCache = new Map();
export function modelURLFromPath(rawPath, origin = location.origin) {
    const href = origin + (rawPath.startsWith('/') ? rawPath : '/' + rawPath);
    if (href.endsWith('.model.json')) {
        return new URL(href);
    }
    return new URL((href + '.model.json').replace('/.', '.'));
}
export const maxPathsToPreload = 50;
let executedLoaders = 0;
let activeLoaders = 0;
let controller = null;
export const clearPreloadCache = () => {
    modelCache.clear();
    executedLoaders = 0;
    activeLoaders = 0;
    controller = null;
};
export async function preloadPath(e, isURL = false) {
    const rawPath = e.detail;
    if (!rawPath) {
        return;
    }
    const url = isURL ? new URL(rawPath) : modelURLFromPath(rawPath, location.origin);
    const key = url.pathname;
    if (modelCache.has(key)) {
        return;
    }
    if (controller) {
        controller.abort();
        controller = null;
        await new Promise((resolve) => setTimeout(resolve, 100));
    }
    /*
      In any case, we should not bloat network pool with more than 1 request at a time
      and more than 50 requests in total, is user reach any cached page, we increase the limit
    */
    if (activeLoaders > 1 || executedLoaders > maxPathsToPreload) {
        // Preload limit reached
        return;
    }
    activeLoaders++;
    controller = new AbortController();
    executedLoaders++;
    const request = fetch(url, {
        signal: controller.signal,
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
    })
        .then((response) => {
        if (response.ok) {
            return response.json().then((result) => {
                if (result && result.hyperdriveEndpoint) {
                    preloadPath(new CustomEvent(PRELOAD_HYPERDRIVE_MODEL_EVENT, {
                        detail: result.hyperdriveEndpoint,
                    }), true);
                }
                return result;
            });
        }
        else {
            throw response;
        }
    })
        .finally(() => {
        activeLoaders--;
        controller = null;
    });
    modelCache.set(key, request);
    request.catch(() => {
        executedLoaders--;
        modelCache.delete(key);
    });
    try {
        await request;
    }
    catch (e) {
        // EOL;
    }
}
export function isPreloaded(path) {
    return modelCache.has(path);
}
export function getPreloadedModel(path) {
    // allow extra preload because we doing good
    executedLoaders--;
    return modelCache.get(path);
}
